import { apiV2, apiPdfServerless } from './api';

export const fetchSchedulePDF = (physicianId: string, startDate: string, endDate: string) => apiV2.get(`/events/event/pdf/?physician=${physicianId}&start_date=${startDate}&end_date=${endDate}&`);
export const getUrlSchedulePDF = (processId: number) => apiPdfServerless.get(`retrieve?process_id=${processId}&token=${process.env.AUTHORIZER_LAMBDA_TOKEN}`);
